import axiosServices from '../utils/axios';
import { CREDITS_ESTIMATION_EVENTS } from '../utils/eventSchema';
const backendUrl = import.meta.env.VITE_BACKEND_URL;

// Subscription product catalog was removed with legacy Stripe billing.
// Keep a stable empty list so onboarding/trial UI can render without 404s.
export const fetchSubscriptionProducts = async () => {
  return [];
};

export const upgradePlan = async (payload, workspaceId) => {
  // Determine active workspace ID
  const wsId = workspaceId || localStorage.getItem('activeWorkspaceId');
  const url = wsId
    ? `${backendUrl}/workspace/${wsId}/create-checkout-session/`
    : `${backendUrl}/create-checkout-session/`; // Fallback (legacy)

  const response = await axiosServices.post(url, payload, {
    withCredentials: true,
  });
  return response.data;
};

// Local entitlement estimate.
export const estimateCredits = async ({
  studyId,
  callType,
  noOfParticipants,
  noOfTranscripts,
  noOfOpenQuestions,
  processId,
  transcriptIds,
  trackEvent,
}) => {
  try {
    const transcriptCount = transcriptIds?.length || noOfTranscripts || 0;
    const response = {
      data: {
        credits_required: transcriptCount + 1,
        analysis_units_required: transcriptCount + 1,
      },
    };
    if (trackEvent) {
      trackEvent('credits_estimation', {
        ...CREDITS_ESTIMATION_EVENTS.CREDITS_ESTIMATION_COMPLETED,
        estimated_credits: response.data.credits_required,
        study_id: studyId,
        call_type: callType,
        participants_count: noOfParticipants,
        transcripts_count: transcriptCount,
        questions_count: noOfOpenQuestions,
        process_id: processId || '',
      });
    }

    return response.data;
  } catch (error) {
    console.error('Error estimating credits:', error);

    throw error;
  }
};
